import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateClassLevelDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code du niveau' })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Libellé du niveau' })
  @IsOptional()
  @IsString()
  label?: string

  @ApiPropertyOptional({ type: 'string', description: "Niveau d'éducation" })
  @IsOptional()
  @IsString()
  educationLevel?: string
}
